import useApi from '../useApi';
import axiosInstance from '../axiosInstance';
import { useCallback, useState } from 'react';

export const useGetHomepageConfig = (options = {}) => {
  return useApi('/cms/layout/homepage-config', {
    method: 'GET',
    ...options,
  });
};

export const useUpdateHomepageConfig = (options = {}) => {
  return useApi('/cms/layout/homepage-config', {
    method: 'PUT',
    ...options,
  });
};

export const useUploadHomepageImage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadImage = useCallback(async (file) => {
    setLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('image', file);
      const { data } = await axiosInstance.post('/cms/layout/homepage-config/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data?.data?.imageUrl ?? null;
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to upload image';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, uploadImage };
};

export const useDeleteHomepageImage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteImage = useCallback(async (imageUrl) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await axiosInstance.delete('/cms/layout/homepage-config/image', {
        data: { imageUrl },
      });
      return data?.success === true;
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to delete image';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, error, deleteImage };
};

export const useGetHomepageImageCapabilities = (options = {}) => {
  return useApi('/cms/layout/homepage-config/image/capabilities', {
    method: 'GET',
    ...options,
  });
};
